var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "184 -776 592 592",
    width: "20px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346-250h268v-52H346v52Zm0-144h268v-52H346v52Zm-69.97 278q-27.03 0-45.53-18.65T212-180.31v-599.38q0-27.01 18.65-45.66Q249.3-844 276.31-844H586l162 162v501.69q0 27.01-18.66 45.66Q710.68-116 683.65-116H276.03ZM548-644v-148H276.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v599.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h407.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-644H548ZM264-792v169-169V-168v-624Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.f7ae5e893837cd64e98125484ed619b9.svg";
export { ForwardRef as ReactComponent };